/**
 * BaseButton registration: the parser. It reuses the Control parse, and property
 * knowledge lives in linterParser.ts.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseControl } from '../../../2d/ui/control/parser';
const baseButtonRegistration = {
    typeName: 'BaseButton',
    parser: parseControl,
};
nodeRegistry.register(baseButtonRegistration);
//# sourceMappingURL=index.js.map